// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xRegex } from "@stanion/XDL/Utilities/validation";

export const xMask = {
    phoneNumber: (value: string) => value.replace(/^(\d{3})(\d{3})(\d)/, "$1-$2-$3"),
    phoneNumberUS: (value: string) => {
        if (!value) {
            return "";
        }
        return value.replace(/^(\d{3})(\d{3})(\d)/, "($1) $2-$3");
    },
    qty: (value: string) => {
        let transformedValue = value;
        if (value) {
            transformedValue = value.replace(xRegex.qty, "") || "1";
        }
        return transformedValue;
    },
};
